import { Link, Typography } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';

export function Copyright(props: TypographyProps) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://madkhol.com">
        Madkhol
      </Link>{' '}
      {new Date().getFullYear()}.
    </Typography>
  );
}
